import { css } from "styled-components";
import { mediaQueries } from "./mixins/breakpoints";
const defaultConstantSpacers = {
    zero: "0px",
    xxxs: "2px",
    xxs: "4px",
    xs: "8px",
    s: "16px",
    sm: "24px",
    m: "32px",
    l: "48px",
    xl: "64px",
    xxl: "96px",
    xxxl: "128px",
};
export const defaultSpacers = {
    constant: defaultConstantSpacers,
    variable: {
        zero: "var(--spacer-variable-zero)",
        xxxs: "var(--spacer-variable-xxxs)",
        xxs: "var(--spacer-variable-xxs)",
        xs: "var(--spacer-variable-xs)",
        s: "var(--spacer-variable-s)",
        sm: "var(--spacer-variable-sm)",
        m: "var(--spacer-variable-m)",
        l: "var(--spacer-variable-l)",
        xl: "var(--spacer-variable-xl)",
        xxl: "var(--spacer-variable-xxl)",
        xxxl: "var(--spacer-variable-xxxl)",
    },
    bladeEdge: {
        left: "var(--blade-edge-left)",
        right: "var(--blade-edge-right)",
        top: "var(--blade-edge-top)",
        topSmall: "var(--blade-edge-top-small)",
        topLarge: "var(--blade-edge-top-large)",
        bottom: "var(--blade-edge-bottom)",
        bottomSmall: "var(--blade-edge-bottom-small)",
        bottomLarge: "var(--blade-edge-bottom-large)",
    },
};
export const variableSpacersMixin = css `
  --spacer-variable-zero: ${defaultConstantSpacers.zero};
  --spacer-variable-xxxs: ${defaultConstantSpacers.xxxs};
  --spacer-variable-xxs: ${defaultConstantSpacers.xxs};
  --spacer-variable-xs: ${defaultConstantSpacers.xs};
  --spacer-variable-s: ${defaultConstantSpacers.s};
  --spacer-variable-sm: ${defaultConstantSpacers.sm};
  --spacer-variable-m: ${defaultConstantSpacers.m};
  --spacer-variable-l: ${defaultConstantSpacers.l};
  --spacer-variable-xl: ${defaultConstantSpacers.xl};
  --spacer-variable-xxl: ${defaultConstantSpacers.xxl};
  --spacer-variable-xxxl: ${defaultConstantSpacers.xxxl};

  ${mediaQueries.tabletDown} {
    --spacer-variable-zero: ${defaultConstantSpacers.zero};
    --spacer-variable-xxxs: ${defaultConstantSpacers.xxxs};
    --spacer-variable-xxs: ${defaultConstantSpacers.xxs};
    --spacer-variable-xs: ${defaultConstantSpacers.xxs};
    --spacer-variable-s: ${defaultConstantSpacers.xs};
    --spacer-variable-sm: ${defaultConstantSpacers.s};
    --spacer-variable-m: ${defaultConstantSpacers.sm};
    --spacer-variable-l: ${defaultConstantSpacers.m};
    --spacer-variable-xl: ${defaultConstantSpacers.l};
    --spacer-variable-xxl: ${defaultConstantSpacers.xl};
    --spacer-variable-xxxl: ${defaultConstantSpacers.xxl};
  }
  ${mediaQueries.mobileDown} {
    --spacer-variable-zero: ${defaultConstantSpacers.zero};
    --spacer-variable-xxxs: ${defaultConstantSpacers.xxxs};
    --spacer-variable-xxs: ${defaultConstantSpacers.xxxs};
    --spacer-variable-xs: ${defaultConstantSpacers.xxs};
    --spacer-variable-s: ${defaultConstantSpacers.xxs};
    --spacer-variable-sm: ${defaultConstantSpacers.xs};
    --spacer-variable-m: ${defaultConstantSpacers.s};
    --spacer-variable-l: ${defaultConstantSpacers.sm};
    --spacer-variable-xl: ${defaultConstantSpacers.m};
    --spacer-variable-xxl: ${defaultConstantSpacers.l};
    --spacer-variable-xxxl: ${defaultConstantSpacers.xl};
  }
`;
export const bladeEdgesMixin = css `
  --blade-edge-left: ${defaultSpacers.variable.l};
  --blade-edge-right: ${defaultSpacers.variable.l};
  --blade-edge-top-large: ${defaultSpacers.variable.xl};
  --blade-edge-top: ${defaultSpacers.variable.l};
  --blade-edge-top-small: ${defaultSpacers.variable.m};
  --blade-edge-bottom-large: ${defaultSpacers.variable.xl};
  --blade-edge-bottom: ${defaultSpacers.variable.l};
  --blade-edge-bottom-small: ${defaultSpacers.variable.m};
`;
//# sourceMappingURL=spacers.js.map